module.exports = __webpack_public_path__ + "img/live-more.f75d65fa.png";